import { Resolve } from '@angular/router';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ResultPageService } from './result-page.service';
import { FlightsAndFiltersResponse } from './_interfaces_/result-page.interface';

@Injectable({
  providedIn: 'root',
})
export class ResultPageResolver {
  constructor(@Inject(ResultPageService) private _resultPageService: ResultPageService) {}

  resolve(): Observable<FlightsAndFiltersResponse> {
    return this._resultPageService.getFlightResultList();
  }
}
